import React, { useEffect, useState } from 'react';
import classes from "./LiveMatches2.module.css";
import Header2 from '../../component/NewComponents/Header2';
import { liveMatchesApi, upcomingMatchesApi, userMatchesApi } from '../../http/http';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import SmallLoader from '../../component/SmallLoader';
import { removeUserDetails } from '../../store/slices/userSlice';
import { toast } from 'react-toastify';
import MatchLayoutNew from '../../component/NewComponents/MatchLayoutNew';
import MatchLiveLayoutNew from '../../component/NewComponents/MatchLiveLayoutNew';
import { useTranslation } from 'react-i18next';

const LiveMatches2 = () => {
    const [liveMatches, setLiveMatches] = useState([]);
    const [upcomingMatches, setUpcomingMatches] = useState([]);
    const { userDetails } = useSelector(state => state?.persisted?.userSlice);
    const [userMatches, setUserMatches] = useState(null);

    const [loader, setLoader] = useState(true);
    const [loading, setLoading] = useState(true);

            const { t } = useTranslation();
    

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const fetchUserMatches = async () => {
        try {
            const response = await userMatchesApi(userDetails?.token);
            setUserMatches({
                fantasy: response?.data?.fantasy,
                prediction: response?.data?.prediction
            });
        } catch (error) {
            if (error?.response?.status == 403) {
                dispatch(removeUserDetails());
                toast.error(t("48"));
                navigate('/');
            } else {
                toast.error(error?.response?.data?.message || error?.response?.message || error?.data?.message || "Something Went Wrong!");
            }
        }
    };

    const fetchLiveMatches = async () => {
        try {
            const response = await liveMatchesApi(userDetails?.token);
            setLiveMatches(response?.data);
        } catch (error) {
            console.log(error, 'error--');
        }
    };

    const fetchUpcomingMatches = async () => {
        try {
            const response = await upcomingMatchesApi(userDetails?.token);
            setUpcomingMatches(response?.data);
        } catch (error) {
            console.error("Error fetching upcoming matches:", error);
        }
    };

    const fetchData = async (load) => {
        if (load) setLoading(true);
        setLoader(true);
        await fetchUserMatches(load);
        await fetchLiveMatches(load);
        await fetchUpcomingMatches(load);
        setLoading(false);
        setLoader(false);
    };

    useEffect(() => { fetchData(true); }, []);

    useEffect(() => {
        if (!loader) {
            const intervalId = setInterval(() => {
                if (!document.hidden) fetchData(false);
            }, 10000);
            return () => clearInterval(intervalId);
        }
    }, [loader]);

    return (
        <div className={classes.page}>
            <Header2 active={2} />

            <main className={classes.main}>

                {/* Hero bar */}
                <div className={classes.heroBar}>
                    <div className={classes.heroText}>
                        <span className={classes.heroEyebrow}>{t("101")} &amp; {t("102")}</span>
                        <h1 className={classes.heroTitle}>{t("103")} <em>&amp; {t("104")}</em></h1>
                    </div>
                    <div className={classes.heroMeta}>
                        {liveMatches.length > 0 && (
                            <span className={classes.liveCountTag}>
                                <span className={classes.liveDot} />
                                {liveMatches.length} {t("105")}
                            </span>
                        )}
                        <span className={classes.upcomingCountTag}>
                            <span className={classes.upcomingDot} />
                            {upcomingMatches.length} {t("106")}
                        </span>
                    </div>
                </div>

                {loading ? (
                    <div className={classes.loaderWrap}>
                        <SmallLoader />
                        <p className={classes.loaderText}>{t("107")}</p>
                    </div>
                ) : (
                    <>
                        {/* Live Matches section */}
                        <div className={classes.sectionHeader}>
                            <span className={classes.sectionDotLive} />
                            <span className={classes.sectionTitle}>{t("108")}</span>
                            <span className={classes.sectionLine} />
                        </div>

                        <div className={classes.matchGrid}>
                            {liveMatches.length > 0 ? (
                                liveMatches.map((match, index) => {
                                    const match_details = JSON.parse(match?.match_details);
                                    return (
                                        <MatchLiveLayoutNew
                                            match={match}
                                            match_details={match_details}
                                            key={index}
                                            index={index}
                                        />
                                    );
                                })
                            ) : (
                                <div className={classes.emptyState}>
                                    <span className={classes.emptyEmoji}>📺</span>
                                    <p className={classes.emptyTitle}>{t("109")}</p>
                                    <p className={classes.emptySub}>{t("110")}</p>
                                </div>
                            )}
                        </div>

                        {/* Upcoming Matches section */}
                        <div className={classes.sectionHeader}>
                            <span className={classes.sectionDot} />
                            <span className={classes.sectionTitle}>{t("111")}</span>
                            <span className={classes.sectionLine} />
                        </div>

                        <div className={classes.matchGrid}>
                            {upcomingMatches.length > 0 ? (
                                upcomingMatches.map((match, index) => (
                                    <MatchLayoutNew
                                        match={match}
                                        key={index}
                                        index={index}
                                        fantasy_match_joined={
                                            userMatches?.fantasy?.filter(d => d?.match_fixture_id == match?.match_fixture_id).length > 0
                                        }
                                        prediction_match_joined={
                                            userMatches?.prediction?.filter(d => d?.match_fixture_id == match?.match_fixture_id).length > 0
                                        }
                                    />
                                ))
                            ) : (
                                <div className={classes.emptyState}>
                                    <span className={classes.emptyEmoji}>⚽</span>
                                    <p className={classes.emptyTitle}>{t("112")}</p>
                                    <p className={classes.emptySub}>{t("113")}</p>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </main>
        </div>
    );
};

export default LiveMatches2;